import React, { useState, useEffect } from "react";
import { InputBase, FormHelperText, ClickAwayListener } from "@mui/material";
import * as yup from "yup";

import { useDispatch } from "react-redux";

const EditableText = ({
  name,
  inputValue,
  placeholder,
  inputClass,
  isDisabled,
  width,
  onChange,
  attr,
  action,
  oldvalue,
  color = "#050D2E",
  // hasPermission = true, //TODO: check if it doesn't affect other features
}) => {
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState("");

  const schema = yup.object({
    name: yup.string().required("Please enter valid name"),
  });

  const validate = () => {
    return yup.reach(schema, attr).validate(inputValue, { abortEarly: false });
  };

  useEffect(() => {
    setOpen(false);
  }, []);
  return (
    <>
      <ClickAwayListener
        onClickAway={() => {
          if (!open) return;
          validate()
            .then((res) => {
              setErr(null);
              setOpen(false);
            })
            .catch((err) => {
              console.log(err);
              setErr(`Please enter a valid ${attr}`);
            });
        }}
      >
        <div>
          <div className={open && "editabel-text-border"}>
            <InputBase
              fullWidth
              sx={{
                color: color,
                fontSize: "14px",
                fontWeight: "bold",
                lineheight: "16px",
              }}
              value={inputValue || ""}
              placeholder={placeholder}
              onChange={(e) => {
                onChange(e.target.value);
              }}
              onFocus={() => setOpen(true)}
              inputProps={{ "aria-label": inputValue, "data-name": name }}
              disabled={isDisabled}
              onBlur={(e) => {
                if (e.target.value.trim() !== oldvalue.name.trim()) {
                  e.stopPropagation();
                  validate()
                    .then((res) => {
                      setErr(null);
                      setOpen(false);
                      e.target.blur();
                      action();
                    })
                    .catch((err) => {
                      console.log(err);
                      setErr(`Please enter a valid ${attr}`);
                    });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.stopPropagation();
                  validate()
                    .then((res) => {
                      setErr(null);
                      setOpen(false);
                      e.target.blur();
                      action();
                    })
                    .catch((err) => {
                      console.log(err);
                      setErr(`Please enter a valid ${attr}`);
                    });
                }
              }}
            />
          </div>
          {err && (
            <FormHelperText
              error
              sx={{
                position: "absolute",
                left: "48%",
              }}
            >
              {err}
            </FormHelperText>
          )}
        </div>
      </ClickAwayListener>
    </>
  );
};

export default EditableText;
